import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../util/axiosBaseQuery";

export interface IssueReportRequest {
  email: string;
  name: string;
  bookingNumber?: string;
  issueType: string;
  locationId: string;
  description: string;
}

export const infoApiSlice = createApi({
  reducerPath: "infoApiSlice",
  baseQuery: axiosBaseQuery(),
  tagTypes: [""],
  endpoints: (builder) => ({
    createIssueReport: builder.mutation<void, IssueReportRequest>({
      query: (data) => ({
        url: "/report-issue",
        method: "POST",
         data,
      }),
    }),
  }),
});

export const { useCreateIssueReportMutation } = infoApiSlice;
